<template>
  <div class="w-100 bg-white">
    <Navbar />
    <block :height="73"></block>
    <div class="ga-container">
      <b-skeleton-wrapper :loading="posContext.is_load">
        <template #loading>
          <b-row class="slim-grid-row mb-3">
            <b-col cols="12" class="mb-2">
              <b-skeleton width="40%" height="56px"></b-skeleton>
              <b-skeleton width="50%" height="30px"></b-skeleton>
            </b-col>
            <b-col cols="8">
              <b-skeleton width="100%" height="400px"></b-skeleton>
            </b-col>
            <b-col cols="4">
              <b-row class="slim-grid-row">
                <b-col cols="6" class="mb-2">
                  <b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
                </b-col>
                <b-col cols="6" class="mb-2">
                  <b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
                </b-col>
                <b-col cols="12" class="mt-2">
                  <b-skeleton width="100%" height="192px" class="mb-0"></b-skeleton>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>

        <div class="w-100 pt-4" v-if="posContext.error != ''">
          <ErrorMessage :message="posContext.error"></ErrorMessage>
        </div>
        <template v-else>
          <!-- TAGLINE & SUBTAGLINE  -->
          <div class="w-100 mb-3">
            <div class="row align-items-center">
              <div class="col-8">
                <p class="mb-0" :class="window_width >= 992 ? 'heading-4-1' : 'heading-5-2'">{{ posContext.general_data.tagline || posContext.general_data.name }}</p>
                <p class="mb-0" :class="window_width >= 992 ? 'body-1' : 'body-2'">{{ posContext.general_data.sub_tagline || posContext.general_data.category }}</p>
              </div>
              <div class="col-4 text-right">
                <button class="g-btn g-btn-primary-outline g-btn-sm px-3" @click="show_detail = true">
                  <svg class="mr-1 mt--2" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="currentColor"/>
                  </svg>
                  Info
                </button>
              </div>
            </div>
          </div>

          <!-- SLIDER -->
          <div class="w-100 mb-4 position-relative">
            <HomeSlider :image_list="posContext.general_data.slider_image || []"></HomeSlider>
          </div>

          <!-- CATEGORY -->
          <div class="w-100 mb-3 sticky-top bg-white z-index-1030 pt-2" style="top: 84px;">
            <div class="w-100 no-ws pb-3" style="overflow-x: auto;white-space: nowrap;">
              <div
                v-for="cat in category_list" :key="cat.id"
                @click="goToCategory(cat.id)"
                class="spa-category-item"
                :class="cat.id == selected_category?'active':''">
                <span :class="cat.id == selected_category?'body-2-4 text-white':'body-2'">{{ cat.name }}</span>
              </div>
            </div>
          </div>

          <!-- MAIN CONTENT -->
          <div class="w-100">
            <div class="row">
              <div class="col-lg-8 col-md-12">
                <div class="pr-xl-5 pr-0">
                  <!-- SKELETON PRODUCT BEST -->
                  <template v-if="posContext.is_load_product_best">
                    <b-skeleton width="200px" height="30px" class="mb-4"></b-skeleton>
                    <div class="row slim-grid-row">
                      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-4" v-for="i in 4" :key="'skeleton_best_'+i">
                        <div class="mb-2 radius-6 overflow-hidden">
                          <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
                        </div>
                        <b-skeleton width="70%" height="20px" class="mb-1"></b-skeleton>
                        <b-skeleton width="40%" height="16px" class="mb-2"></b-skeleton>
                        <b-skeleton width="100%" height="36px" class="radius-6"></b-skeleton>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="w-100 mb-5 category-section" id="category-product-best">
                      <span id="product-best"></span>
                      <p class="mb-4 heading-6-1">Best Seller</p>
                      <div class="row slim-grid-row">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-4" v-for="best_product in posContext.product_best" :key="best_product.id">
                          <Product type="square" :data="best_product" :config-data="posContext.general_data" />
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- SKELETON PRODUCT LIST -->
                  <template v-if="posContext.is_load_product_list">
                    <div class="w-100 mb-4" v-for="i in 2" :key="'skeleton_cat_'+i">
                       <b-skeleton width="150px" height="30px" class="mb-4"></b-skeleton>
                       <div class="row">
                         <div class="col-12 col-lg-6 mb-4" v-for="j in 2" :key="'skeleton_prod_'+j">
                            <div class="row no-gutters">
                              <div class="col-4">
                                <b-skeleton-img no-aspect height="110px" class="radius-6"></b-skeleton-img>
                              </div>
                              <div class="col-8">
                                <div class="pl-3">
                                  <b-skeleton width="60%" height="20px" class="mb-1"></b-skeleton>
                                  <b-skeleton width="100%" height="16px" class="mb-2"></b-skeleton>
                                  <b-skeleton width="80px" height="32px"></b-skeleton>
                                </div>
                              </div>
                            </div>
                         </div>
                       </div>
                    </div>
                  </template>
                  <template v-else>
                    <div v-for="category in posContext.product_per_category" :key="category.id" :id="'category-'+category.id" class="w-100 mb-5 category-section">
                      <p class="mb-4 heading-6-1">{{ category.name }}</p>
                      <div class="row">
                        <div class="col-12 col-lg-6 mb-4" v-for="(product, product_i) in category.products" :key="product.id">
                          <Product type="block" :data="product" :index="product_i" :products_length="category.products.length" :config-data="posContext.general_data" />
                        </div>
                        <template v-if="category.page === 0 && category.has_more">
                          <div class="col-12 col-lg-6 mb-4" v-for="i in 4" :key="'skeleton_cat_prod_'+i">
                            <div class="row no-gutters">
                              <div class="col-4">
                                <b-skeleton-img no-aspect height="110px" class="radius-6"></b-skeleton-img>
                              </div>
                              <div class="col-8">
                                <div class="pl-3">
                                  <b-skeleton width="60%" height="20px" class="mb-1"></b-skeleton>
                                  <b-skeleton width="100%" height="16px" class="mb-2"></b-skeleton>
                                  <b-skeleton width="80px" height="32px"></b-skeleton>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <InfiniteScrollTrigger
                        :has-more="category.has_more"
                        :is-loading="category.is_loading_more"
                        :is-paused="posContext.is_category_jumping"
                        :show-spinner="category.page > 0"
                        @reach="posContext.loadMoreCategoryProducts(category)" />
                    </div>
                  </template>
                </div>
              </div>

              <!-- DESKTOP SUMMARY -->
              <div class="col-lg-4 col-md-12" v-if="window_width >= 992">
                <div class="general-booking-summary sticky-top" style="top: 150px;">
                  <div class="radius-12 bg-white box-shadow-light-aff border-semi-grey overflow-hidden">
                    <div class="p-4 bg-top-black">
                      <p class="mb-0 body-2-2 font-semibold text-16 text-white">Order Summary</p>
                      <p class="mb-0 body-2-2 font-bold text-20 text-white">{{ getMerchant ? getMerchant.name : '' }}</p>
                    </div>
                    <div class="px-4 py-4 border-b-semi-grey" v-if="getOutletTrxProducts && getOutletTrxProducts.length > 0">

                      <div class="w-100" v-for="(product,product_i) in getOutletTrxProducts">
                        <ProductCart :data="product" :product_index="product_i" />
                      </div>
                    </div>
                    <div class="w-100 p-4">
                      <div class="row" v-if="hasSeparateTaxService">
                        <div class="col-6">
                          <p class="mb-2 body-2-2">Subtotal</p>
                        </div>
                        <div class="col-6 text-right">
                          <p class="mb-2 font-lato text-14">{{ $formatCurrency(getOutletTrxDisplaySubTotal) }}</p>
                        </div>
                        <div class="col-6">
                          <p class="mb-3 body-2-2">Tax &amp; Service</p>
                        </div>
                        <div class="col-6 text-right">
                          <p class="mb-3 font-lato text-14">{{ $formatCurrency(getOutletTrxDisplayTaxService) }}</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <p class="mb-0 heading-6-1">Total</p>
                        </div>
                        <div class="col-8 text-right">
                          <p class="text-20 font-lato mb-0">{{ $formatCurrency(getOutletTrxTotal) }}</p>
                        </div>
                        <div class="col-12 mt-4" v-if="getOutletTrxProducts && getOutletTrxProducts.length > 0">
                          <button class="g-btn g-btn-primary-outline g-btn-lg w-100" @click="goToPageCart()">Proceed Ordering</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- MOBILE SUMMARY -->
              <div class="w-100 fixed-bottom py-4 bg-white" v-if="window_width < 992 && getOutletTrxProducts && getOutletTrxProducts.length > 0" style="z-index: 1040;">
                <div class="ga-container">
                  <div class="w-100 bg-green radius-12 px-4 py-3">
                    <div class="row align-items-center">
                      <div class="col-sm-8 col-6">
                        <p class="mb-0 font-lato text-white" :class="window_width >= 576 ? 'text-18' : 'text-16'">{{ $formatCurrency(getOutletTrxTotal) }}</p>
                        <div class="w-100 no-ws">
                          <p class="mb-0 text-light d-inline-block align-middle" :class="window_width >= 576 ? 'body-2-4' : 'body-3-3-2'">{{ posContext.getOutletTrxTotalItem }} Item(s)<template v-if="hasSeparateTaxService"> &middot; incl. tax &amp; service</template></p>
                        </div>
                      </div>
                      <div class="col-sm-4 col-6">
                        <button @click="goToPageCart()" type="button" class="button-primary text-right text-14 w-100">Order Now<img src="../../../../../assets/img/icon/back-white.png" class="ml-1 position-relative transform-180" style="top: -1px;" width="18"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </template>
      </b-skeleton-wrapper>
    </div>

    <Footer></Footer>
    <PosDetailPopup v-model="show_detail" :data="posContext.general_data" />
    
    <b-modal
      v-model="posContext.product_detail_popup.show"
      centered size="md" hide-header hide-footer body-class="p-0 overflow-hidden">
      <div class="w-100" v-if="posContext.product_detail_popup.show">
        <ProductDetail 
          page_module="outlet" 
          :detail_data="{ pos_id: posContext.product_detail_popup.pos_id, product_id: posContext.product_detail_popup.product_id }" 
          @close="posContext.product_detail_popup.show = false" />
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex';
  import Navbar from '@/components/hotel/concierge/general/Navbar';
  import Footer from '@/components/hotel/concierge/general/Footer';
  import HomeSlider from '@/components/general/HomeSlider';
  import Product from '@/components/hotel/concierge/pos/Product';
  import ProductCart from '@/components/hotel/concierge/pos/ProductCart';
  import PosDetailPopup from '@/components/hotel/concierge/pos/PosDetailPopup';
  import ProductDetail from '@/pages/hotel/concierge/pos/ProductDetail';
  import InfiniteScrollTrigger from '@/components/v2/InfiniteScrollTrigger';

  export default {
    components: {
      Navbar,
      Footer,
      HomeSlider,
      Product,
      ProductCart,
      PosDetailPopup,
      ProductDetail,
      InfiniteScrollTrigger
    },
    inject: ['posContext'],
    data() {
      return {
        window_width: window.innerWidth,
        selected_category: 'all',
        show_detail: false
      }
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
        window.addEventListener('scroll', this.updateScroll);
        setTimeout(() => this.updateScroll(), 500);
      })
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResizeWindow);
      window.removeEventListener('scroll', this.updateScroll);
    },
    computed: {
      ...mapGetters(['getOutletTrxProducts','getOutletTrxTotal','getOutletTrxDisplaySubTotal','getOutletTrxDisplayTaxService','getMerchant']),
      hasSeparateTaxService(){
        return this.getOutletTrxDisplayTaxService > 0
      },
      category_list() {
        let list = [];
        if (this.posContext.product_per_category) {
          list = this.posContext.product_per_category.map(cat => ({
            id: cat.id,
            name: cat.name
          }));
        }
        list.unshift({ id: 'all', name: 'All Categories' });
        return list;
      },
    },
    methods: {
      ...mapMutations(['removeTrxOutletProduct']),
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      updateScroll() {
        let scrollY = window.scrollY;
        let threshold = scrollY + (window.innerHeight * 0.25);

        let activeId = 'all';
        let found = false;

        if (this.posContext.product_per_category) {
          for (let i = this.posContext.product_per_category.length - 1; i >= 0; i--) {
            let cat = this.posContext.product_per_category[i];
            let el = document.getElementById('category-' + cat.id);
            if (el) {
              let rect = el.getBoundingClientRect();
              let elementTop = rect.top + scrollY;

              if (elementTop <= threshold) {
                activeId = cat.id;
                found = true;
                break;
              }
            }
          }
        }

        if (!found) {
           activeId = 'all';
        }

        this.selected_category = activeId;
      },
      goToCategory(id) {
        this.posContext.jumpToCategory(behavior => this.scrollToCategory(id, behavior));
      },
      scrollToCategory(id, behavior) {
        let targetId = id === 'all' ? 'category-product-best' : 'category-' + id;
        let el = document.getElementById(targetId);
        if (el) {
          let offset = 175;
          let rect = el.getBoundingClientRect();
          let targetPosition = rect.top + window.scrollY - offset;

          window.scrollTo({
            top: targetPosition,
            behavior: behavior
          });
        }
      },
      removeProductCart(product_cart) {
        let params = {
          product: product_cart.product_data,
          variant: product_cart.variants || [],
          qty: 0,
          notes: product_cart.notes,
          page_module: this.posContext.getOutletTrxPageModule
        }
        this.removeTrxOutletProduct(params)
      },
      goToPageCart() {
        let route = {
          name: 'PosCart',
          params: {
            merchant_code: this.posContext.getMerchant.code,
            pos_code: this.posContext.pos_code
          }
        }
        this.$router.push(route)
      }
    }
  }
</script>
<style scoped>
  .card-product-height {
    height: 200px;
  }
  .category-section {
     scroll-margin-top: 150px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/layouts/PosWideLayout.vue